module.exports = {
      id: "icon-check-list-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-check-list",
      toString: function () {
        return this.url;
      }
    }